import { api1C } from './api';

export const load1cProvisions = (params) => {
    return api1C.get(`provisions`, {
        params,
    });
}